import { baseApi } from '@/config/axios';
import {
  CustomerInfoApiParams,
  CustomerInfoApiResponse,
  UpdateEmailApiParams,
  UpdateEmailApiResponse,
  UpdatePasswordApiParams,
  UpdatePasswordApiResponse,
} from '@/types/api/customerApi';
import {
  UpdateWarrantyCustomerParams,
  UpdateWarrantyCustomerResponse,
} from '@/types/api/warrantyApi';
import {
  registerCustomerInfoRestrictionRequest,
  startPrepaidRestrictionRequest,
} from '@/utils/prepaidRestrictionRequest';

// 5.基礎情報取得
export const customerInfoApi = (
  params: CustomerInfoApiParams,
): Promise<CustomerInfoApiResponse> => {
  const requestId = startPrepaidRestrictionRequest();
  return baseApi
    .get('v1/customer/info', { params })
    .then((response: CustomerInfoApiResponse) => {
      registerCustomerInfoRestrictionRequest(response.data.customer, {
        customerId: params.m_customer_id,
        requestId,
      });
      return response;
    });
};

// 26. パスワード変更
export const updatePasswordApi = (
  params: UpdatePasswordApiParams,
): Promise<UpdatePasswordApiResponse> =>
  baseApi.put('v1/customer/password-change', { ...params });

// 75. メールアドレス変更処理
export const updateEmailApi = (
  params: UpdateEmailApiParams,
): Promise<UpdateEmailApiResponse> =>
  baseApi.put('v1/customer/email-change', { ...params });

// 21. お客様情報更新
export const updateCustomerApi = (
  params: UpdateWarrantyCustomerParams,
): Promise<UpdateWarrantyCustomerResponse> =>
  baseApi.put('v1/customer', params);
